"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _toolkit = require('@reduxjs/toolkit');




var _common = require('shared/selectors/blobject/common');

 const selectConversationByKey =
  (state, k) => state.dataV2.conversations[k]; exports.selectConversationByKey = selectConversationByKey

 const selectConversationType = _toolkit.createSelector.call(void 0, 
  _common.selectBlobjectByKey,
  b => _optionalChain([b, 'optionalAccess', _ => _.WrappedType]) || null,
); exports.selectConversationType = selectConversationType

const EMPTY_LIST = []
 const selectMessagesByConversationKey = _toolkit.createSelector.call(void 0, 
  [
    (state, k) => state.dataV2.messages[k] || EMPTY_LIST,
    (state, k) => _optionalChain([state, 'access', _2 => _2.dataV2, 'access', _3 => _3.pendingReactions, 'optionalAccess', _4 => _4[k]]),
    (state) => state.dataV2.currentUser.UserKey,
  ],
  (messages, pending, currentUserKey) => {
    if (!pending || Object.keys(pending).length === 0) return messages

    let didChange = false
    const mergedMessages = messages.map(message => {
      const pendingForMessage = pending[message.MessageKey]
      if (!pendingForMessage) return message

      let reactions = message.Reactions || []
      let reactionsChanged = false
      Object.entries(pendingForMessage).forEach(([emoji, entry]) => {
        const hasOwnReaction = reactions.some(
          reaction => reaction.Emoji === emoji && reaction.UserKey === currentUserKey,
        )

        if (entry.op === 'add' && !hasOwnReaction) {
          reactions = [
            ...reactions,
            { Emoji: emoji, UserKey: currentUserKey, CreatedAt: entry.at },
          ]
          reactionsChanged = true
        } else if (entry.op === 'remove' && hasOwnReaction) {
          reactions = reactions.filter(
            reaction => !(reaction.Emoji === emoji && reaction.UserKey === currentUserKey),
          )
          reactionsChanged = true
        }
      })

      if (!reactionsChanged) return message
      didChange = true
      return { ...message, Reactions: reactions }
    })

    return didChange ? mergedMessages : messages
  },
  { memoize: _toolkit.lruMemoize, memoizeOptions: { maxSize: 10 } },
); exports.selectMessagesByConversationKey = selectMessagesByConversationKey

 const selectMessageByKey = _toolkit.createSelector.call(void 0, 
  [
    (state, conversationKey) =>
      state.dataV2.messages[conversationKey] || EMPTY_LIST,
    (_state, _conversationKey, messageKey) => messageKey,
  ],
  (messages, messageKey) => messages.find(message => message.MessageKey === messageKey),
  { memoize: _toolkit.lruMemoize, memoizeOptions: { maxSize: 20 } },
); exports.selectMessageByKey = selectMessageByKey

 const selectReplyTargetFacts = _toolkit.createSelector.call(void 0, 
  [exports.selectMessageByKey],
  (message) => {
    if (!message) return undefined

    return {
      recalled: message.Deleted,
      displayName: message.DisplayName,
      senderType: message.SenderType,
      snippet: message.MessageType === 'text' || message.MessageType === 'auto_reply'
        ? _optionalChain([message, 'access', _5 => _5.MessageText, 'optionalAccess', _6 => _6.slice, 'call', _7 => _7(0, 120)])
        : undefined,
      fileName: message.MessageType === 'file' ? message.FileName : undefined,
      thumbnailURL: _optionalChain([message, 'access', _8 => _8.FileInfo, 'optionalAccess', _9 => _9.PreviewUrl]) || _optionalChain([message, 'access', _10 => _10.FileInfo, 'optionalAccess', _11 => _11.ThumbnailURL]),
      mime: _optionalChain([message, 'access', _12 => _12.FileInfo, 'optionalAccess', _13 => _13.Mime]) || _optionalChain([message, 'access', _14 => _14.FileInfo, 'optionalAccess', _15 => _15.LocalMime]),
      fileKey: _optionalChain([message, 'access', _16 => _16.FileInfo, 'optionalAccess', _17 => _17.FileKey]) || message.FileReference,
    }
  },
  { memoize: _toolkit.lruMemoize, memoizeOptions: { maxSize: 20 } },
); exports.selectReplyTargetFacts = selectReplyTargetFacts

 const selectInboxHasAlert = (state) =>
  state.dataV2.inducedValues.inboxHasAlert; exports.selectInboxHasAlert = selectInboxHasAlert
